<template>
  <!-- 修改密码页面 -->
  <div class="bgs">
    <el-tabs v-model="activeName">
      <el-tab-pane label="修改密码" name="first">
        <el-row>
          <el-col :span="12">
            <el-form :model="ruleForm" :rules="rules" ref="formData" label-width="100px" class="demo-ruleForm">
              <el-form-item label="旧密码" prop="old_pwd">
                <el-input type="password" v-model="ruleForm.old_pwd"></el-input>
              </el-form-item>

              <el-form-item label="新密码" prop="new_pwd">
                <el-input type="password" v-model="ruleForm.new_pwd"></el-input>
              </el-form-item>

              <el-form-item label="重复新密码" prop="re_pwd">
                <el-input type="password" v-model="ruleForm.re_pwd"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="On_re_pwd('formData')">立即修改</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { password } from "../../api/api";
import Axios from "axios"
export default {
  metaInfo(){
     return{
        title: '修改密码',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  data() {
    return {
      activeName: "first",
      token:localStorage.getItem("token"),
      ruleForm: {
        old_pwd: "",
        new_pwd: "",
        re_pwd: "",
      },
      rules: {
        old_pwd: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 6, max: 20, message: "长度在6到20个字符", trigger: "blur" },
        ],
        new_pwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 20, message: "长度在6到20个字符", trigger: "blur" },
        ],
        re_pwd: [
          { required: true, message: "请输入重复新密码", trigger: "blur" },
          { min: 6, max: 20, message: "长度在6到20个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    On_re_pwd(formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          var that=this;
          Axios.post("https://weixin.qudong.com/api/user/change_pass", {
           new_password:this.ruleForm.new_pwd,
          password:this.ruleForm.old_pwd,
          repeat_password:this.ruleForm.re_pwd,
          token:this.token
        }).then(function (res) {
          ////console.log(res);
         if (res.data.code == 200) {
              that.$message.success("修改成功");
              setTimeout(function () {
                history.go(0);
              }, 500);
            } else {
              that.$message.success(res.data.msg);
            }
        });
        }
      });
    },
  },
};
</script>

<style scoped>
.bgs {
  width: 940px;
  height: 730px;
  background: #fff;
  padding: 30px;
}
</style>